(function() {
  'use strict';

  var STORAGE_KEY = 'avangard-lang';
  var PERSIAN_RE = /[\u0600-\u06FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  var isApplying = false;

  /* =============================================
     TRANSLATION DICTIONARIES
     ============================================= */

  var translations = {
    'Add to cart': '\u0627\u0641\u0632\u0648\u062f\u0646 \u0628\u0647 \u0633\u0628\u062f \u062e\u0631\u06cc\u062f',
    'Sold out': '\u0646\u0627\u0645\u0648\u062c\u0648\u062f',
    'Unavailable': '\u0646\u0627\u0645\u0648\u062c\u0648\u062f',
    'Sale': '\u062a\u062e\u0641\u06cc\u0641',
    'Share': '\u0627\u0634\u062a\u0631\u0627\u06a9\u200c\u06af\u0630\u0627\u0631\u06cc',
    'Quantity': '\u062a\u0639\u062f\u0627\u062f',
    'Search': '\u062c\u0633\u062a\u062c\u0648',
    'Cart': '\u0633\u0628\u062f \u062e\u0631\u06cc\u062f',
    'Close': '\u0628\u0633\u062a\u0646',
    'Menu': '\u0645\u0646\u0648',
    'View all': '\u0645\u0634\u0627\u0647\u062f\u0647 \u0647\u0645\u0647',
    'Continue shopping': '\u0627\u062f\u0627\u0645\u0647 \u062e\u0631\u06cc\u062f',
    'Your cart is empty': '\u0633\u0628\u062f \u062e\u0631\u06cc\u062f \u0634\u0645\u0627 \u062e\u0627\u0644\u06cc \u0627\u0633\u062a',
    'Subtotal': '\u062c\u0645\u0639 \u06a9\u0644',
    'Total': '\u062c\u0645\u0639 \u06a9\u0644',
    'Check out': '\u067e\u0631\u062f\u0627\u062e\u062a',
    'Checkout': '\u067e\u0631\u062f\u0627\u062e\u062a',
    'Taxes and shipping calculated at checkout': '\u0645\u0627\u0644\u06cc\u0627\u062a \u0648 \u0647\u0632\u06cc\u0646\u0647 \u0627\u0631\u0633\u0627\u0644 \u062f\u0631 \u0632\u0645\u0627\u0646 \u067e\u0631\u062f\u0627\u062e\u062a \u0645\u062d\u0627\u0633\u0628\u0647 \u0645\u06cc\u200c\u0634\u0648\u062f',
    'Update': '\u0628\u0647\u200c\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06cc',
    'Remove': '\u062d\u0630\u0641',
    'Subscribe': '\u0639\u0636\u0648\u06cc\u062a',
    'Subscribe to our emails': '\u0639\u0636\u0648\u06cc\u062a \u062f\u0631 \u062e\u0628\u0631\u0646\u0627\u0645\u0647',
    'Email': '\u0627\u06cc\u0645\u06cc\u0644',
    'Log in': '\u0648\u0631\u0648\u062f',
    'Create account': '\u0627\u06cc\u062c\u0627\u062f \u062d\u0633\u0627\u0628',
    'Account': '\u062d\u0633\u0627\u0628 \u06a9\u0627\u0631\u0628\u0631\u06cc',
    'Description': '\u062a\u0648\u0636\u06cc\u062d\u0627\u062a',
    'You may also like': '\u067e\u06cc\u0634\u0646\u0647\u0627\u062f \u0645\u0627',
    'Regular price': '\u0642\u06cc\u0645\u062a',
    'Unit price': '\u0642\u06cc\u0645\u062a \u0648\u0627\u062d\u062f',
    'Choose options': '\u0627\u0646\u062a\u062e\u0627\u0628',
    'Quick add': '\u0627\u0641\u0632\u0648\u062f\u0646 \u0633\u0631\u06cc\u0639',
    'Filter and sort': '\u0641\u06cc\u0644\u062a\u0631 \u0648 \u0645\u0631\u062a\u0628\u200c\u0633\u0627\u0632\u06cc',
    'Sort by': '\u0645\u0631\u062a\u0628\u200c\u0633\u0627\u0632\u06cc',
    'Availability': '\u0645\u0648\u062c\u0648\u062f\u06cc',
    'Price': '\u0642\u06cc\u0645\u062a',
    'In stock': '\u0645\u0648\u062c\u0648\u062f',
    'Out of stock': '\u0646\u0627\u0645\u0648\u062c\u0648\u062f',
    'No products found': '\u0645\u062d\u0635\u0648\u0644\u06cc \u06cc\u0627\u0641\u062a \u0646\u0634\u062f',
    'Use fewer filters or clear all': '\u0641\u06cc\u0644\u062a\u0631\u0647\u0627\u06cc \u06a9\u0645\u062a\u0631\u06cc \u0627\u0633\u062a\u0641\u0627\u062f\u0647 \u06a9\u0646\u06cc\u062f',
    'Clear all': '\u067e\u0627\u06a9 \u06a9\u0631\u062f\u0646 \u0647\u0645\u0647',
    'Apply': '\u0627\u0639\u0645\u0627\u0644',
    'Home': '\u062e\u0627\u0646\u0647',
    'All Products': '\u0647\u0645\u0647 \u0645\u062d\u0635\u0648\u0644\u0627\u062a',
    'All products': '\u0647\u0645\u0647 \u0645\u062d\u0635\u0648\u0644\u0627\u062a',
    'Collections': '\u062f\u0633\u062a\u0647\u200c\u0628\u0646\u062f\u06cc\u200c\u0647\u0627',
    'Quick Links': '\u0644\u06cc\u0646\u06a9\u200c\u0647\u0627\u06cc \u0633\u0631\u06cc\u0639',
    'Quick links': '\u0644\u06cc\u0646\u06a9\u200c\u0647\u0627\u06cc \u0633\u0631\u06cc\u0639',
    'Payment methods': '\u0631\u0648\u0634\u200c\u0647\u0627\u06cc \u067e\u0631\u062f\u0627\u062e\u062a',
    'Read more': '\u0628\u06cc\u0634\u062a\u0631 \u0628\u062e\u0648\u0627\u0646\u06cc\u062f',
    'Show more': '\u0646\u0645\u0627\u06cc\u0634 \u0628\u06cc\u0634\u062a\u0631',
    'Show less': '\u0646\u0645\u0627\u06cc\u0634 \u06a9\u0645\u062a\u0631',
    'Loading': '\u062f\u0631 \u062d\u0627\u0644 \u0628\u0627\u0631\u06af\u0630\u0627\u0631\u06cc',
    'of': '\u0627\u0632',
    'products': '\u0645\u062d\u0635\u0648\u0644',
    'product': '\u0645\u062d\u0635\u0648\u0644',
    'items': '\u0645\u0648\u0631\u062f',
    'item': '\u0645\u0648\u0631\u062f',
    'Decrease quantity for': '\u06a9\u0627\u0647\u0634 \u062a\u0639\u062f\u0627\u062f',
    'Increase quantity for': '\u0627\u0641\u0632\u0627\u06cc\u0634 \u062a\u0639\u062f\u0627\u062f',
    'Shipping': '\u0627\u0631\u0633\u0627\u0644',
    'Free shipping': '\u0627\u0631\u0633\u0627\u0644 \u0631\u0627\u06cc\u06af\u0627\u0646'
  };

  var reverseTranslations = {};
  for (var en in translations) {
    reverseTranslations[translations[en]] = en;
  }

  var tableLabels = {
    '\u0646\u0648\u06cc\u0633\u0646\u062f\u0647': 'Author',
    '\u0645\u062a\u0631\u062c\u0645': 'Translator',
    '\u0646\u0627\u0634\u0631': 'Publisher',
    '\u062a\u0639\u062f\u0627\u062f \u0635\u0641\u062d\u0627\u062a': 'Pages',
    '\u0648\u0632\u0646': 'Weight',
    '\u0634\u0627\u0628\u06a9': 'ISBN',
    '\u0633\u0627\u0644 \u0627\u0646\u062a\u0634\u0627\u0631': 'Year',
    '\u0686\u0627\u067e': 'Edition',
    '\u0642\u0637\u0639': 'Format',
    '\u0627\u0646\u062f\u0627\u0632\u0647': 'Size',
    '\u062c\u0644\u062f': 'Binding',
    '\u0632\u0628\u0627\u0646': 'Language',
    '\u0634\u0645\u0627\u0631\u0647': 'Issue',
    '\u062f\u0648\u0631\u0647': 'Volume',
    '\u0641\u0635\u0644': 'Season',
    '\u0633\u0627\u0644': 'Year',
    '\u0645\u0648\u0636\u0648\u0639': 'Subject'
  };

  var reverseTableLabels = {};
  for (var fa in tableLabels) {
    reverseTableLabels[tableLabels[fa]] = fa;
  }

  /* =============================================
     UTILITY FUNCTIONS
     ============================================= */

  function getLang() {
    return localStorage.getItem(STORAGE_KEY) || 'fa';
  }

  function isPersian(text) {
    return PERSIAN_RE.test(text);
  }

  function splitBilingual(text, lang) {
    if (!text || text.indexOf(' | ') === -1) return null;
    var parts = text.split(' | ');
    if (parts.length !== 2) return null;
    var p0P = isPersian(parts[0].trim());
    return lang === 'fa'
      ? (p0P ? parts[0].trim() : parts[1].trim())
      : (p0P ? parts[1].trim() : parts[0].trim());
  }

  function hasPersianContent(text) {
    if (!text) return false;
    return PERSIAN_RE.test(text);
  }

  /* =============================================
     TEXT NODE PROCESSING
     ============================================= */

  function processTextNodes(el, lang) {
    var nodes = el.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 3) {
        var text = node.textContent.trim();
        if (text.indexOf(' | ') !== -1) {
          if (!node._origText) node._origText = text;
          var result = splitBilingual(node._origText, lang);
          if (result !== null) {
            node.textContent = ' ' + result;
          }
        }
      }
    }
  }

  function processSimpleElement(el, lang) {
    if (!el.hasAttribute('data-orig')) {
      var t = el.textContent.trim();
      if (t.indexOf(' | ') !== -1) {
        el.setAttribute('data-orig', t);
      }
    }
    var orig = el.getAttribute('data-orig');
    if (orig) {
      var result = splitBilingual(orig, lang);
      if (result !== null) el.textContent = result;
    }
  }

  /* =============================================
     MAIN APPLY FUNCTION
     ============================================= */

  function applyLang(lang) {
    if (isApplying) return;
    isApplying = true;

    try {
      // 1. BILINGUAL ELEMENTS
      document.querySelectorAll([
        '.banner__heading', '.banner__text',
        '.rich-text__heading',
        '.section-header__title',
        '.announcement-bar__message',
        '.footer-block__heading',
        '.footer-block__heading.inline-richtext',
        'a.full-unstyled-link',
        'span.full-unstyled-link',
        '.button__label',
        'a.button',
        '.banner__buttons a',
        '.multicolumn-card__info h3',
        '.newsletter__subheading'
      ].join(', ')).forEach(function(el) {
        if (el.querySelector('h1,h2,h3,h4,h5,h6,div')) return;
        processSimpleElement(el, lang);
      });

      // 2. HEADINGS
      document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function(el) {
        if (el.querySelector('svg')) {
          processTextNodes(el, lang);
        } else if (!el.querySelector('h1,h2,h3,h4,h5,h6,div')) {
          processSimpleElement(el, lang);
        }
      });

      // 3. MENU ITEMS
      document.querySelectorAll('.header__menu-item, .list-menu__item--link, .mega-menu__link').forEach(function(el) {
        var span = el.querySelector('span');
        var target = span || el;
        processSimpleElement(target, lang);
      });

      // 4. ACCORDION TITLES
      document.querySelectorAll('.accordion__title, summary .summary__title').forEach(function(el) {
        processTextNodes(el, lang);
      });

      // 5. SHARE BUTTON
      document.querySelectorAll('share-button span, .share-button__fallback, [class*="share"] span').forEach(function(el) {
        processSimpleElement(el, lang);
      });

      // 6. PARAGRAPHS - Show/Hide by language
      document.querySelectorAll('.rich-text__text, .footer-block__details, .footer-block__details-content, .multicolumn-card__info .rte, .newsletter__subheading').forEach(function(container) {
        var paragraphs = container.querySelectorAll('p');
        if (paragraphs.length < 2) return;
        var hasPer = false, hasEng = false;
        paragraphs.forEach(function(p) {
          var t = p.textContent.trim();
          if (!t) return;
          if (hasPersianContent(t)) hasPer = true;
          else hasEng = true;
        });
        if (hasPer && hasEng) {
          paragraphs.forEach(function(p) {
            var t = p.textContent.trim();
            if (!t) return;
            var pIsPersian = hasPersianContent(t);
            p.style.display = (lang === 'fa') ? (pIsPersian ? '' : 'none') : (pIsPersian ? 'none' : '');
          });
        }
      });

      // 7. ACCORDION CONTENT paragraphs
      document.querySelectorAll('.accordion__content .rte').forEach(function(container) {
        var paragraphs = container.querySelectorAll('p');
        if (paragraphs.length < 2) return;
        var hasPer = false, hasEng = false;
        paragraphs.forEach(function(p) {
          var t = p.textContent.trim();
          if (!t) return;
          if (hasPersianContent(t)) hasPer = true;
          else hasEng = true;
        });
        if (hasPer && hasEng) {
          paragraphs.forEach(function(p) {
            var t = p.textContent.trim();
            if (!t) return;
            var pIsPersian = hasPersianContent(t);
            p.style.display = (lang === 'fa') ? (pIsPersian ? '' : 'none') : (pIsPersian ? 'none' : '');
          });
        }
      });

      // 8. PRODUCT INFO TABLE LABELS
      document.querySelectorAll('.book-details table td').forEach(function(td) {
        var text = td.textContent.trim();
        if (!td.hasAttribute('data-orig-label')) {
          if (td.style.fontWeight === 'bold' || (td.getAttribute('style') && td.getAttribute('style').indexOf('font-weight: bold') !== -1)) {
            td.setAttribute('data-orig-label', text);
          }
        }
        var origLabel = td.getAttribute('data-orig-label');
        if (origLabel) {
          if (lang === 'en' && tableLabels[origLabel]) {
            td.textContent = tableLabels[origLabel];
          } else if (lang === 'fa') {
            td.textContent = origLabel;
          }
        }
      });

      // 9. BOOK DESCRIPTION DIRECTION
      document.querySelectorAll('.book-description, .product__description .rte').forEach(function(el) {
        el.style.direction = 'rtl';
        el.style.textAlign = 'right';
      });

      // 10. SHOPIFY UI TEXT
      var map = lang === 'fa' ? translations : reverseTranslations;
      document.querySelectorAll([
        'button span', '.button span', '.product-form__submit span',
        'a span', 'label', 'summary span',
        '.cart-notification__heading', '.cart-count-bubble span',
        '.predictive-search__heading', '.field__label',
        '.cart-drawer__footer span', '.totals__subtotal',
        '.tax-note',
        '.quick-add__submit', '.card__link'
      ].join(', ')).forEach(function(el) {
        if (el.id === 'lang-toggle-btn' || el.classList.contains('lang-icon')) return;
        if (el.closest('#lang-toggle-btn')) return;

        var nodes = el.childNodes;
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          if (node.nodeType === 3) {
            var trimmed = node.textContent.trim();
            if (!trimmed) continue;
            if (map[trimmed]) {
              node.textContent = node.textContent.replace(trimmed, map[trimmed]);
            }
          }
        }
      });

      // 11. NEWSLETTER HEADINGS
      document.querySelectorAll('.newsletter__heading, .newsletter h2').forEach(function(el) {
        processSimpleElement(el, lang);
      });

      // 12. FOOTER LINKS
      document.querySelectorAll('.footer-block .list-menu__item, .footer-block .list-menu__item--link, .footer-block a').forEach(function(el) {
        processSimpleElement(el, lang);
      });

      // 13. BODY CLASSES + dir attribute for CSS RTL mirroring
      if (lang === 'fa') {
        document.body.classList.add('lang-rtl');
        document.body.classList.remove('lang-ltr');
        document.documentElement.lang = 'fa';
        document.documentElement.dir = 'rtl';
      } else {
        document.body.classList.add('lang-ltr');
        document.body.classList.remove('lang-rtl');
        document.documentElement.lang = 'en';
        document.documentElement.dir = 'ltr';
      }

    } finally {
      isApplying = false;
    }
  }

  /* =============================================
     TOGGLE BUTTON
     ============================================= */

  function updateToggleButton(lang) {
    var btn = document.getElementById('lang-toggle-btn');
    if (btn) {
      btn.innerHTML = lang === 'fa'
        ? '<span class="lang-icon">EN</span>'
        : '<span class="lang-icon">\u0641\u0627</span>';
      btn.title = lang === 'fa' ? 'Switch to English' : '\u062a\u063a\u06cc\u06cc\u0631 \u0628\u0647 \u0641\u0627\u0631\u0633\u06cc';
    }
  }

  function createToggle() {
    if (document.getElementById('lang-toggle-btn')) return;
    var headerIcons = document.querySelector('.header__icons');
    if (!headerIcons) return;

    var btn = document.createElement('button');
    btn.id = 'lang-toggle-btn';
    btn.className = 'header__icon lang-toggle-button';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Toggle language');
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Add transition class to mask reflow
      document.body.classList.add('lang-switching');

      var next = getLang() === 'fa' ? 'en' : 'fa';
      localStorage.setItem(STORAGE_KEY, next);
      document.documentElement.setAttribute('data-lang', next);

      // Apply after a tiny delay to let the fade start
      requestAnimationFrame(function() {
        applyLang(next);
        updateToggleButton(next);

        // Remove transition class after content settles
        setTimeout(function() {
          document.body.classList.remove('lang-switching');
        }, 200);
      });
    });
    headerIcons.insertBefore(btn, headerIcons.firstChild);
  }

  /* =============================================
     INITIALIZATION
     ============================================= */

  function init() {
    createToggle();
    var lang = getLang();
    document.documentElement.setAttribute('data-lang', lang);
    applyLang(lang);
    updateToggleButton(lang);
  }

  // Prevent flash of wrong language — set early
  (function() {
    var lang = localStorage.getItem(STORAGE_KEY) || 'fa';
    document.documentElement.setAttribute('data-lang', lang);
    document.documentElement.lang = lang === 'fa' ? 'fa' : 'en';
    document.documentElement.dir = lang === 'fa' ? 'rtl' : 'ltr';
    // Add body class early via inline style to prevent flash
    var style = document.createElement('style');
    style.textContent = lang === 'fa'
      ? 'body{} body.lang-ltr{} '
      : 'body{} body.lang-rtl{} ';
    document.head.appendChild(style);
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() { createToggle(); applyLang(getLang()); }, 300);
  });

  var debounceTimer = null;
  var observer = new MutationObserver(function(mutations) {
    if (isApplying) return;
    var dominated = false;
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1) {
          var t = n.tagName;
          if (t === 'SECTION' || t === 'MAIN' || t === 'FOOTER' || t === 'HEADER' ||
              (n.classList && (n.classList.contains('shopify-section') ||
                n.classList.contains('product-grid') ||
                n.classList.contains('cart-drawer') ||
                n.classList.contains('cart-notification') ||
                n.classList.contains('predictive-search') ||
                n.classList.contains('quick-add-modal')))) {
            dominated = true; break;
          }
        }
      }
      if (dominated) break;
    }
    if (dominated) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { applyLang(getLang()); }, 300);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();